import { FormattedMessage } from "react-intl"
import {
  DirectboxReceive,
  Heart,
  Music,
  Profile2User,
  MoneyChange,
  VolumeSlash,
  Buildings,
  Layer,
  Graph,
  Money,
  HuobiToken,
  MusicPlaylist,
  Smileys,
  MusicSquare,
  People,
  WalletMoney,
  MoneyTick,
  DocumentUpload
} from "iconsax-react"
import { NavItemType } from "types/menu"
import { UserRoles } from "types/auth"

const icons = {
  hotlist: HuobiToken,
  playlist: MusicPlaylist,
  tracks: Music,
  releases: MusicSquare,
  artists: Profile2User,
  unitPriceDashboard: MoneyChange,
  inbounds: DirectboxReceive,
  shortlist: Heart,
  blacklist: VolumeSlash,
  companyBreakdown: Layer,
  affiliate: Smileys,
  offersReports: Graph,
  company: Buildings,
  confirmedOffers: Money,
  deals: MoneyTick,
  reportUploadRequests: DocumentUpload,
  dealsReport: WalletMoney,
  spotifyArtistRequest: People
}

const scoutingNavItems: NavItemType = {
  id: "navigation",
  title: <FormattedMessage id="navigation" />,
  type: "group",
  children: [
    {
      id: "playlist",
      title: <FormattedMessage id="playlist" />,
      type: "item",
      url: "/playlist",
      icon: icons.playlist,
      roleIds: [UserRoles.SCOUTING_ADMIN, UserRoles.SCOUTING_ACCESS]
    },
    {
      id: "tracks",
      title: <FormattedMessage id="tracks" />,
      type: "item",
      url: "/tracks",
      icon: icons.tracks,
      roleIds: [UserRoles.SCOUTING_ADMIN, UserRoles.SCOUTING_ACCESS]
    },
    {
      id: "artists",
      title: <FormattedMessage id="artists" />,
      type: "item",
      icon: icons.artists,
      url: "/artists",
      roleIds: [UserRoles.SCOUTING_ADMIN, UserRoles.SCOUTING_ACCESS, UserRoles.ACCOUNT, UserRoles.OUTREACH]
    },
    {
      id: "releases",
      title: <FormattedMessage id="releases" />,
      type: "item",
      icon: icons.releases,
      url: "/releases",
      roleIds: [UserRoles.SCOUTING_ADMIN, UserRoles.SCOUTING_ACCESS]
    },
    {
      id: "affiliate",
      title: <FormattedMessage id="affiliate" />,
      type: "item",
      url: "/scout",
      icon: icons.affiliate,
      roleIds: [UserRoles.SCOUTING_ADMIN]
    },
    {
      id: "blacklist",
      title: <FormattedMessage id="blacklist" />,
      type: "item",
      icon: icons.blacklist,
      url: "/blacklist",
      roleIds: [UserRoles.BLACK_LIST_VALIDATOR]
    },
    {
      id: "unitPriceDashboard",
      title: <FormattedMessage id="unitPriceDashboard" />,
      type: "item",
      icon: icons.unitPriceDashboard,
      url: "/unit-price-dashboard",
      roleIds: [UserRoles.SCOUTING_ADMIN, UserRoles.SCOUTING_ACCESS]
    },
    {
      id: "offersReports",
      title: <FormattedMessage id="offersReports" />,
      type: "item",
      url: "/offers-reports",
      icon: icons.offersReports,
      roleIds: [UserRoles.SCOUTING_ADMIN, UserRoles.SCOUTING_ACCESS]
    },
    {
      id: "companyBreakdown",
      title: <FormattedMessage id="companyBreakdown" />,
      type: "item",
      url: "/company-breakdown",
      icon: icons.companyBreakdown,
      roleIds: [UserRoles.BLACK_LIST_VALIDATOR]
    },
    {
      id: "company",
      title: <FormattedMessage id="company" />,
      type: "item",
      url: "/company",
      icon: icons.company,
      roleIds: [UserRoles.BLACK_LIST_VALIDATOR]
    },
    {
      id: "spotifyArtistRequest",
      title: <FormattedMessage id="spotifyArtistRequest" />,
      type: "item",
      url: "/spotify-artist-request",
      icon: icons.spotifyArtistRequest,
      roleIds: [UserRoles.SCOUTING_ADMIN]
    },
    {
      id: "reportUploadRequests",
      title: <FormattedMessage id="reportUploadRequests" />,
      type: "item",
      url: "/report-upload-requests",
      icon: icons.reportUploadRequests,
      roleIds: [UserRoles.SCOUTING_SUPER_ADMIN, UserRoles.SCOUTING_ADMIN, UserRoles.SCOUTING_ACCESS]
    },
    {
      id: "confirmedOffers",
      title: <FormattedMessage id="confirmedOffers" />,
      type: "item",
      url: "/confirmed-offers",
      icon: icons.confirmedOffers,
      roleIds: [UserRoles.SCOUTING_ADMIN, UserRoles.SCOUTING_ACCESS, UserRoles.BUYOUT_OFFER]
    },
    {
      id: "deals",
      title: <FormattedMessage id="deals" />,
      type: "item",
      url: "/deals",
      icon: icons.deals,
      roleIds: [UserRoles.SCOUTING_SUPER_ADMIN]
    },
    {
      id: "dealsReport",
      title: <FormattedMessage id="dealsReport" />,
      type: "item",
      url: "/deals-report",
      icon: icons.dealsReport,
      roleIds: [UserRoles.SCOUTING_SUPER_ADMIN]
    }
  ]
}

export default scoutingNavItems
